import { render, staticRenderFns } from "./IconDeleteRow.vue?vue&type=template&id=be100b40"
import script from "./IconDeleteRow.vue?vue&type=script&lang=js"
export * from "./IconDeleteRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports